import servicenow from '~/images/servicenow.png'
import { ImgHTMLAttributes } from 'react'

const ServiceNowLogo = (props: ImgHTMLAttributes<HTMLImageElement>) => (
  <img src={servicenow} {...props} alt="" />
)

export default ServiceNowLogo
